import { render, staticRenderFns } from "./BatteryDiagnosticsList.vue?vue&type=template&id=64cd0de4&scoped=true"
import script from "./BatteryDiagnosticsList.vue?vue&type=script&lang=js"
export * from "./BatteryDiagnosticsList.vue?vue&type=script&lang=js"
import style0 from "./BatteryDiagnosticsList.vue?vue&type=style&index=0&id=64cd0de4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd0de4",
  null
  
)

export default component.exports